/**
 * Normalize permissions from API: backend may send array of strings or array of { key, description }.
 * Returns array of permission key strings for CASL/ability.
 */
export const normalizePermissions = (permissions) => {
    if (!Array.isArray(permissions)) return [];
    return permissions
        .map((p) =>
            typeof p === 'object' && p != null && typeof p.key === 'string' ? p.key : typeof p === 'string' ? p : null,
        )
        .filter(Boolean);
};

export const PERMISSIONS_STORAGE_KEY = 'code360-permissions';

export const setPermissionsInLocalStorage = (permissions) => {
    try {
        if (permissions && permissions.length) {
            localStorage.setItem(PERMISSIONS_STORAGE_KEY, JSON.stringify(permissions));
        } else {
            localStorage.removeItem(PERMISSIONS_STORAGE_KEY);
        }
    } catch (e) {
        // ignore
    }
};
